import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/contacto/page.tsx");
